import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGlobalChat } from '../../contexts/GlobalChatContext';
import { LeadWhatsappChat } from '../leads/LeadWhatsappChat';
import { useAuth } from '../../hooks/useAuth';
import { MessageCircle, X } from 'lucide-react';

export function FloatingChat() {
  const { activeChatLead, closeChat } = useGlobalChat();
  const { company } = useAuth();
  const location = useLocation();
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    if (location.pathname.startsWith('/inbox')) {
      closeChat();
    }
  }, [location.pathname, closeChat]);

  // Reset minimized state when opening a new chat
  useEffect(() => {
    if (activeChatLead) {
      setIsMinimized(false);
    }
  }, [activeChatLead]);

  if (!activeChatLead || !company || location.pathname.startsWith('/inbox')) return null;

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        className="fixed bottom-6 right-6 z-50 p-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full shadow-lg shadow-green-500/30 hover:scale-105 hover:shadow-xl hover:shadow-green-500/40 transition-all duration-300 animate-in zoom-in-95 group flex items-center gap-3"
      >
        <div className="relative">
          <MessageCircle size={28} />
          <span className="absolute -top-1 -right-1 flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
          </span>
        </div>
        <div className="flex flex-col items-start pr-2 overflow-hidden max-w-[150px]">
          <span className="text-xs font-bold truncate w-full">{activeChatLead.name || 'Sem Nome'}</span>
          <span className="text-[11px] font-medium opacity-90">Chat em andamento</span>
        </div>
        <div 
          className="ml-2 p-1 hover:bg-white/20 rounded-full transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            closeChat();
          }}
        >
          <X size={16} />
        </div>
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 w-[420px] bg-white dark:bg-slate-900 rounded-3xl overflow-hidden border border-gray-200/60 dark:border-gray-700/60 shadow-[0_8px_30px_rgb(0,0,0,0.12)] dark:shadow-[0_8px_30px_rgb(0,0,0,0.4)] animate-in slide-in-from-bottom-8 zoom-in-95 fade-in duration-300 ease-out ring-1 ring-black/5 dark:ring-white/5">
      <LeadWhatsappChat 
        lead={activeChatLead} 
        company={company} 
        onClose={() => setIsMinimized(true)}
      />
    </div>
  );
}
